import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Miami.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose Us for Software Development in Miami?</h2>
            <p>
              When you choose us, you are selecting a software development
              company Miami with an established track record of successful
              project delivery.
            </p>
            <p>
              Our software developers in Miami are well-versed in developing
              high-performance, scalable software solutions by utilizing
              cutting-edge tools and techniques, ensuring your software is not
              just up-to-date but also leads the industry in terms of standards
              and innovation.
            </p>
            <p>
              What sets us apart is our deep understanding of local market
              dynamics, the latest industry trends, and the fast-paced nature of
              Miami's business environment. With over a decade of industry
              experience, we are well-equipped to manage software development
              Miami projects of all complexity levels.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
